export default __webpack_public_path__ + "images/icon-check-blue.png";